const getElementPositionRelativeToDocument = element =>
    element ? element.getBoundingClientRect().top + document.documentElement.scrollTop : null;

const getElementLeft = element => (element ? element.getBoundingClientRect().left : 0);

const getElement = (name, formName) =>
    document.getElementById(`${name}-${formName}`) ||
    document.getElementsByName(name)[0] ||
    null;

const findFirstInvalid = (errors, formName) => {
    const positions = Object.keys(errors)
        .map(name => {
            const elt = getElement(name, formName);
            const pos = getElementPositionRelativeToDocument(elt);
            return pos ? { name, pos, left: getElementLeft(elt), elt } : null;
        })
        .filter(p => !!p);

    if (positions.length === 0) return null;

    return positions.reduce((acc, cur) => {
        if (cur.pos < acc.pos) return cur;
        if (cur.pos > acc.pos) return acc;
        return cur.left < acc.left ? cur : acc;
    }, positions[0]);
};

export const scrollToInvalid = (errors, dispatch, submitError, props) => {
    if (!errors) return;

    const formName = props && props.form ? props.form : '';

    // Laisser React rendre l'état d'erreur avant de positionner le focus
    const apply = () => {
        const invalidInput = findFirstInvalid(errors, formName);
        if (invalidInput && invalidInput.elt) {
            window.scrollTo(0, invalidInput.pos - 50);
            invalidInput.elt.focus();
        }
    };

    if (typeof window !== 'undefined' && window.requestAnimationFrame) {
        window.requestAnimationFrame(apply);
    } else {
        apply();
    }
};



// WEBPACK FOOTER //
// ./src/components/form/utils.js